module.exports = __webpack_public_path__ + "img/whatsapp.ac017f9a.svg";